import React, { useState } from 'react';
import { Link } from 'react-router-dom';

type AlbumCardProps = {
	id: number;
	title: string;
	coverPhoto: string;
	isFeatured?: boolean;
};

const AlbumCard: React.FC<AlbumCardProps> = ({ id, title, coverPhoto, isFeatured = false }) => {
	const [loaded, setLoaded] = useState(false);

	return (
		<div className={`transition-all duration-200 ${isFeatured ? 'group relative' : 'bg-gray-50 border border-gray-200 hover:border-black hover:shadow-lg'}`}>
			<Link to={`/albums/${id}/photos`} className="block overflow-hidden">
				{/* Image Container */}
				<div className="relative w-full aspect-[4/3] bg-gray-100">
					{/* Skeleton Loader */}
					<div className={`skeleton ${loaded ? 'hidden-skeleton' : ''}`} />

					{/* Cover Image */}
					<img
						src={coverPhoto}
						alt={title}
						loading="lazy"
						className={`w-full h-full object-cover transition-all duration-300 ${loaded ? 'opacity-100' : 'opacity-0'
							} ${isFeatured ? 'group-hover:scale-105' : ''}`}
						onLoad={() => setLoaded(true)}
					/>

					{/* Featured Album Title Overlay */}
					{isFeatured && (
						<div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent flex items-end p-6">
							<h3 className="text-gray-50 text-2xl font-semibold">{title}</h3>
						</div>
					)}
				</div>

				{/* Non-Featured Album Title */}
				{!isFeatured && (
					<div className="p-6">
						<h3 className="text-gray-900 text-lg font-medium">{title}</h3>
					</div>
				)}
			</Link>
		</div>
	);
};

export default AlbumCard;
